<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="30%" :mask-closable="false" :closable="false">
		
			<Form :rules="ruleInline" label-position="right" v-if="modal.type=='add'||modal.type=='up'" ref="userForm"
				:model="userInfo" :label-width="90">
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem :label="$t('UserManagement.UserAccount')" prop="Name">
						<Input :disabled="modal.canInput" v-model="userInfo.Name" :placeholder="$t('UserManagement.UserAccount')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$t('UserManagement.UserName')" prop="DisplayName">
						<Input :disabled="modal.canInput" v-model="userInfo.DisplayName" :placeholder="$t('UserManagement.UserName')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24" style="margin-bottom: 10px;">
					<Col span=12>
					<FormItem :label="$t('UserManagement.LoginPwd')" prop="Password">
						<Input :disabled="modal.type=='up'" v-model="userInfo.Password" :placeholder="$t('UserManagement.LoginPwd')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$t('Common.Email')" prop="Email">
						<Input :disabled="modal.canInput" v-model="userInfo.Email" :placeholder="$t('Common.Email')"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem :label="$t('Common.Phone')" prop="Phone">
						<Input :disabled="modal.canInput" v-model="userInfo.Phone" :placeholder="$t('Common.Phone')"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem :label="$t('Common.Status')" prop="Status">
						<Select :disabled="modal.canInput" :placeholder="$t('Common.Status')" v-model="userInfo.Status">
							<Option :value='0'> {{ $t('UserManagement.Normal') }}</Option>
							<Option :value='9'> {{ $t('UserManagement.Lock') }}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span=12>
					<FormItem :label="$t('Common.Role')" prop="RoleId">
						<Select :placeholder="$t('Common.Role')" v-model="userInfo.RoleId">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in RoleList" :value="item.Id">
								{{item.RoleName}}</Option>
						</Select>
						<!-- <Input :disabled="modal.canInput" v-model="userInfo.RoleId" placeholder="RoleId"></Input> -->
					</FormItem>
					</Col>
					<Col span=12>
				
					<FormItem :label="$t('Common.Operator')" prop="OperatorId">
						
						<Select :disabled="modal.canInput" :placeholder="$t('Common.Operator')" v-model="userInfo.OperatorId">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in OperatorStation"
								:value="item.OperatorId">{{item.OperatorName}}</Option>
						</Select>
					</FormItem>
					</Col>
		
				</Row>
				<Row :gutter="24">
					<Col span=24>
					<FormItem prop="StationArray" :label="$t('UserManagement.LimitStations')">
						<Select :max-tag-count='4' :placeholder="$t('UserManagement.LimitStationsDesc')" multiple v-model="userInfo.StationArray">
							<Option v-bind:key="itemIndex" v-for="(item,itemIndex) in OperatorStationFilter"
								:value="item.StationId">{{item.StationName}}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
			
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{ $t('Common.Add') }}</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" @click="modalOk('up')" size="large">{{ $t('Common.Edit') }}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import dateFormat from '../../../../../public/js/comm.js'
	import webapi from '../../../../webapi.js';
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (this.modal.type == 'up') {
					callback();
				} else {
					if (value === '') {
						callback(new Error(this.$t('UserManagement.InputPassword')));
					} else {
						callback();
					}
				}
			};
			return {
				modal: {
					Title: this.$t('UserManagement.AddUser'),
					type: "add",
					ifShow: false,
					canInput: false
				},

				userInfo: {
				
					"Id": 0,
					"Name": "",
					"DisplayName": "",
					"Password": "",
					"Email": "",
					"Phone": "",
					"Status": 0,
					"RoleId": 2,
					"OperatorId": "",
					"StationList": "[]",
					"StationArray": [],
					"CreateBy": 0,
					"CreateTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"ModifyBy": 0,
					"ModifyTime": dateFormat.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
					"Creator": "string",
					"Modifier": "string"
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,


				OperatorStation: [],

				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					Name: [{
						required: true,
						message: this.$t('UserManagement.UserAccount'),
						trigger: 'blur'
					}],
					DisplayName: [{
						required: true,
						message: this.$t('UserManagement.UserName'),
						trigger: 'blur'
					}],
					Password: [{
						validator: validateOpId,
						trigger: 'blur',
					}],
		
				},
			};
		},
		methods: {

			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = this.$t('UserManagement.AddUser');
					_this.modal.type = "add";
					_this.ruleInline.Password.required = true;
					_this.userInfo.Id = 0;
					_this.$refs.userForm.resetFields()
				} else if (type == "up") {
					_this.modal.Title = this.$t('UserManagement.EditUser');
					_this.modal.type = "up";
					_this.ruleInline.Password.required = false;
					_this.$refs.userForm.resetFields()
					console.log(params)
					_this.userInfo = {
						"Id": params.Id,
						"Name": params.Name,
						"DisplayName": params.DisplayName,
						"Password": params.Password,
						"Email": params.Email,
						"Phone": params.Phone,
						"Status": params.Status,
						"RoleId": params.RoleId,
						"OperatorId": params.OperatorId,
						"StationList": params.StationList,
						"StationArray": params.StationArray,
						"CreateBy": params.CreateBy,
						"CreateTime": params.CreateTime,
						"ModifyBy": params.ModifyBy,
						"ModifyTime": params.ModifyTime,
						"Creator": params.Creator,
						"Modifier": params.Modifier,
					};
				}
				_this.modal.ifShow = true
			},
	
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addUser(type);
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addUser(type);
						break;
					default:
						break;
				}
			},

			addUser: function(type) {
				const _this = this;
				_this.$refs.userForm.validate((valid) => {
					console.log("User " + type + "----" + valid)
					if (valid) {
						let parms = _this.userInfo
						console.log(_this.userInfo)
						_this.$axios.post(webapi.base_api_url + "/System/AddUser", parms, {}).then(res => {
							console.log("Add User")
							console.log(res.data)
							if (res.data.Code == 0) {
								this.$Message.success(type == 'add' ? this.$t('Common.AddSuccess') : this.$t('Common.EditSuccess'));
								_this.$emit('handleSubmit');
								_this.modalOk("cancle")
							} else {
								this.$Message.error(res.data.Msg + "---" + res.data.Data);
							}
						})
					}
				})
			},
			GetCurrentOperatorStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/System/GetCurrentOperatorStation", {}, {}).then(res => {
					console.log("GetCurrentOperatorStation")
					console.log(res.data)
					if (res.data.Code == 0) {
						_this.OperatorStation = res.data.Data.List
					} else {
						_this.$Message.error(res.data.Msg + "---" + res.data.Data);
					}
				})
			},
			/**********Component Method*********/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('delete picture cache')
				} else {
					console.log('picture cache is not exist')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {

					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('Common.FormatError'),
					desc: this.$t('Common.SelectJpgOrPng')
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$t('Common.ImageTooLarge'),
					desc: this.$t('Common.File') + file.name + ' '+this.$t('Common.SelectSmallerImg')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
		created() {
			this.GetCurrentOperatorStation()
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
		
			OperatorStationFilter: function() {
				const _this = this
				let staArr = []
				_this.OperatorStation.forEach(function(item, index, arr) {
					if (item.OperatorId == _this.userInfo.OperatorId) {
						staArr = (item.Stations)
					}
				})
				console.log(staArr);
				return staArr
			},
			...mapState({
				StationList: 'Stations',
				RoleList: 'roleList',
				OperatortypeList: 'typeList'
			})
		}
	}
</script>

<style>
</style>
